export const parseQueryString = (query: string): Record<string, string | number> => {
  return query.split('&').reduce<Record<string, string | number>>((acc, pair) => {
    const [key, value] = pair.split('=');
    acc[key] = isNaN(Number(value)) ? value : Number(value);
    return acc;
  }, {});
};